import { useEffect } from 'react'
import { NotificationItem } from './NotificationItem'
import * as S from './MobileNotificationModal.styles'
import { AFbLink } from 'components/FbUI/FbLink/styles'
import {
  useListNotifications,
  useMarkAllNotificationsAsRead,
} from 'services/notifications'
import { toast } from 'react-toastify'
import { BsX } from 'react-icons/bs'

export type MobileNotificationModalProps = {
  clickOutsideClassName: string
  onClickOutside: () => void
  stickToRight?: boolean
}

export const MobileNotificationModal = ({
  clickOutsideClassName,
  onClickOutside,
  stickToRight = false,
}: MobileNotificationModalProps) => {
  // Trigger onClickOutside when user clicks outside of the NotificationContainer
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement
      if (target.closest(clickOutsideClassName) === null) {
        onClickOutside()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [onClickOutside])

  const { data: unreadNotifications } = useListNotifications({
    is_read: false,
  })

  const { data: readNotifications } = useListNotifications({
    is_read: true,
  })

  const markAllAsRead = useMarkAllNotificationsAsRead()

  const handleMarkAllAsRead = () => {
    markAllAsRead.mutate(undefined, {
      onError: () => {
        toast.error('Failed to mark all notifications as read')
      },
    })
  }

  return (
    <S.NotificationContainer stickRight={stickToRight}>
      <S.NotificationHeader>
        Notifications
        <BsX onClick={onClickOutside} />
      </S.NotificationHeader>
      {!unreadNotifications?.length && !readNotifications?.length && (
        <S.NotificationSubHeader>
          <div>
            👋 Hey there! 📬 You have no notifications right now. Enjoy some
            notification-free time!
          </div>
        </S.NotificationSubHeader>
      )}
      {!!unreadNotifications?.length && (
        <>
          <S.NotificationSubHeader>
            <div>Unread</div>
            <AFbLink href="#" onClick={handleMarkAllAsRead}>
              Mark all as read
            </AFbLink>
          </S.NotificationSubHeader>
          {unreadNotifications.map((notification) => (
            <NotificationItem
              isUnread
              key={notification.id}
              notification={notification}
              onClick={onClickOutside}
            />
          ))}
        </>
      )}
      {!!readNotifications?.length && (
        <>
          <S.NotificationSubHeader>
            <div>Read</div>
          </S.NotificationSubHeader>
          {readNotifications.map((notification) => (
            <NotificationItem
              key={notification.id}
              notification={notification}
              onClick={onClickOutside}
            />
          ))}
        </>
      )}
    </S.NotificationContainer>
  )
}
